import { render } from "./NewsSection.vue?vue&type=template&id=c823e28e&scoped=true"
import script from "./NewsSection.vue?vue&type=script&lang=js"
export * from "./NewsSection.vue?vue&type=script&lang=js"

import "./NewsSection.vue?vue&type=style&index=0&id=c823e28e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c823e28e"]])

export default __exports__